import React from "react";
import { PngCare } from "../assets";
import Footer from "../components/Footer";

export default function Care() {
  return (
    <>
      {" "}
      <section className="about__hero">
        <img
          loading="lazy"
          className="about__hero__img"
          src={PngCare}
          alt=" At AFF, we pioneer evocative aromas and tastes that inspire and endure. As an ambitious trailblazer in Asia, we envision a world where every Scent tells a story, and every Flavor is a journey AdvancedFF, a leader in global Flavors & Fragrances, offers cutting-edge aromatic solutions, bespoke scents, and innovative flavor creations. With a commitment to excellence, our natural extracts, culinary aromas, and custom fragrance formulations redefine sensory experiences. Explore our diverse range of gourmet essences, aroma compounds, and unique fragrances crafted with expertise. From scent marketing to personalized aromatics, our top-rated flavor and fragrance design elevate culinary sensations. AdvancedFF sets the standard in fragrance trends, delivering premium scents, bespoke flavoring, and unparalleled fragrance diversity. Experience the artistry of AdvancedFF, where advanced technology meets olfactory mastery for a world-class sensory journey ,AdvancedFF, a leader in global Flavors & Fragrances, offers cutting-edge aromatic solutions, bespoke scents, and innovative flavor creations. With a commitment to excellence, our natural extracts, culinary aromas, and custom fragrance formulations redefine sensory experiences. Explore our diverse range of gourmet essences, aroma compounds, and unique fragrances crafted with expertise. From scent marketing to personalized aromatics, our top-rated flavor and fragrance design elevate culinary sensations. AdvancedFF sets the standard in fragrance trends, delivering premium scents, bespoke flavoring, and unparalleled fragrance diversity. Experience the artistry of AdvancedFF, where advanced technology meets olfactory mastery for a world-class sensory journey,advancedffwebsite aff  aff website   advancedff advancedff.com advancedff advancedff advancedgg advancedff advancedgg affwebsite  Advanced Flavors & Fragrances Pte. Ltd. Advanced Flavors & Fragrances Pte. Ltd. Advanced Flavors and  Flavors & Fragrances Pte. Ltd. advnacedff   flavour flavour singapore advancedff-Image Containg Buildings"
        />
        <div className="about__hero__content">
          <div className="about__hero__content__heading">AFF Care</div>
        </div>
      </section>
      <section className="carepage__section">
        <div className="carepage__section__content">
          <div className="carepage__section__content__info">
            Lorem Ipsum is simply dummy text of the printing and typesetting
            industry. Lorem Ipsum has been the industry's standard dummy text
            ever since the 1500s, when an unknown printer took a galley of type
            and scrambled it to make a type specimen book. It has survived not
            only five centuries, but also the leap into electronic typesetting,
            remaining essentially unchanged. It was popularised in the 1960s
            with the release of Letraset sheets containing Lorem Ipsum passages,
            and more recently with desktop publishing software like Aldus
            PageMaker including versions of Lorem Ipsum.
          </div>
          <div className="carepage__section__content__cards">
            <div className="carepage__section__content__cards__left">
              <div className="carepage__section__content__cards__left__content">
                <div className="carepage__section__content__cards__right__content__heading">
                  Lorem Ipsum 
                </div>
                <div className="carepage__section__content__cards__left__content__points">
                  <li>
                    {" "}
                    Lorem Ipsum is simply dummy text of the printing dummy text
                    of the printing
                  </li>
                  <li> Lorem Ipsum is simply dummy text of the printing.</li>
                  <li>
                    {" "}
                    Lorem Ipsum is simply dummy text of the printing dummy text
                    of the printing
                  </li>
                  <li>
                    {" "}
                    Lorem Ipsum is simply dummy text of the printing dummy text
                    of the printing
                  </li>
                </div>
              </div>
            </div>
            <div className="carepage__section__content__cards__right">
              <div className="carepage__section__content__cards__right__content">
                <div className="carepage__section__content__cards__right__content__heading">
                  Join AFF Care
                </div>
                <div className="carepage__section__content__cards__right__content__input">
                  <div className="Register__page__content__form__inputs">
                    <div className="contact__content__left__row__reg__icon__care">
                      <svg
                        width="17"
                        height="13"
                        viewBox="0 0 17 13"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M14.0365 0.171875H2.95313C2.32324 0.171875 1.71915 0.422098 1.27375 0.867496C0.828348 1.3129 0.578125 1.91699 0.578125 2.54687V10.4635C0.578125 11.0934 0.828348 11.6975 1.27375 12.1429C1.71915 12.5883 2.32324 12.8385 2.95313 12.8385H14.0365C14.6663 12.8385 15.2704 12.5883 15.7158 12.1429C16.1612 11.6975 16.4115 11.0934 16.4115 10.4635V2.54687C16.4115 1.91699 16.1612 1.3129 15.7158 0.867496C15.2704 0.422098 14.6663 0.171875 14.0365 0.171875ZM13.506 1.75521L8.49479 5.51562L3.48354 1.75521H13.506ZM14.0365 11.2552H2.95313C2.74316 11.2552 2.5418 11.1718 2.39333 11.0233C2.24487 10.8749 2.16146 10.6735 2.16146 10.4635V2.74479L8.01979 7.13854C8.15683 7.24132 8.3235 7.29687 8.49479 7.29687C8.66609 7.29687 8.83276 7.24132 8.96979 7.13854L14.8281 2.74479V10.4635C14.8281 10.6735 14.7447 10.8749 14.5963 11.0233C14.4478 11.1718 14.2464 11.2552 14.0365 11.2552Z"
                          fill="#7E7E7E"
                        />
                      </svg>

                      <Input
                        name="Lorem Ipsum is simply dummy text "
                        type="text"
                        title="Lorem Ipsum is simply dummy text "
                        placeholder="Lorem Ipsum is simply dummy text "
                      />
                    </div>
                  </div>
                  <div className="carepage__section__content__cards__right__content__input__button__div">
                    <button className="carepage__section__content__cards__right__content__input__button">
                      Send Request
                    </button>{" "}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="carepage__section__content__info">
            Lorem Ipsum is simply dummy text of the printing and typesetting
            industry. Lorem Ipsum has been the industry's standard dummy text
            ever since the 1500s, when an unknown printer took a galley of type
            and scrambled it to make a type specimen book. It has survived not
            only five centuries, but also the leap into electronic typesetting,
            remaining essentially unchanged. It was popularised in the 1960s
            with the release of Letraset sheets containing Lorem Ipsum passages,
            and more recently with desktop publishing software like Aldus
            PageMaker including versions of Lorem Ipsum.Lorem Ipsum is simply
            dummy text of the printing and typesetting industry. Lorem Ipsum has
            been the industry's standard dummy text ever since the 1500s, when
            an unknown printer took a galley of type and scrambled it to make a
            type specimen book. It has survived not only five centuries, but
            also the leap into electronic typesetting, remaining essentially
            unchanged. It was popularised in the 1960s with the release of
            Letraset sheets containing Lorem Ipsum passages, and more recently
            with desktop publishing software like Aldus PageMaker including
            versions of Lorem Ipsum.
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}
function Input({ textarea, required, label, error, list, ...props }) {
  return (
    <div className="contact__content__left__input__reg">
      {textarea ? (
        <textarea
          {...props}
          cols="30"
          rows="10"
          className="contact__content__left__input__field__reg__care"
          required={required}
          style={{ padding: "1em" }}
        />
      ) : (
        <input
          {...props}
          className="contact__content__left__input__field__reg__care"
          required={required}
          list={label + "s"}
          id={label}
        />
      )}
      {error !== "" ? (
        <div className="contact__content__left__input__error">{error}</div>
      ) : null}
      {list ? (
        <datalist id={label + "s"}>
          {list.map((item, i) => (
            <option key={i} value={item} />
          ))}
        </datalist>
      ) : null}
    </div>
  );
}
